module.exports = __webpack_public_path__ + "img/fa-regular-400.b8ec4531.svg";